/* Created by Interactive 63 - https://interactive63.com */
/**
 * The attributes an exported root `<svg>` carries: sizing, and either an accessible name or a
 * hint for screen readers to skip the graphic.
 */
import type { ExportSettings, Project } from '../model/types';

const SVG_NS = 'http://www.w3.org/2000/svg';

/**
 * Applies sizing and accessibility attributes to the root. Responsive output has no width or
 * height; otherwise the original size is used, falling back to the viewBox size.
 */
export function applyRootAttributes(
  root: Element,
  project: Project,
  settings: ExportSettings,
  sceneName: string,
): void {
  const { svg } = project;
  if (settings.responsive) {
    root.removeAttribute('width');
    root.removeAttribute('height');
  } else {
    root.setAttribute('width', svg.originalWidth ?? String(svg.viewBox.width));
    root.setAttribute('height', svg.originalHeight ?? String(svg.viewBox.height));
  }

  const title = settings.accessibleTitle.trim();
  if (title === '') {
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('focusable', 'false');
    return;
  }
  const titleId = `${sceneName}-title`;
  root.setAttribute('role', 'img');
  root.setAttribute('aria-labelledby', titleId);
  const element = root.ownerDocument.createElementNS(SVG_NS, 'title');
  element.setAttribute('id', titleId);
  element.textContent = title;
  root.insertBefore(element, root.firstChild);
}
